module.exports = __webpack_public_path__ + "img/giverise-logo.b3d17c39.svg";